import DashboardContent from "./DashboardContent";

export default DashboardContent;
